import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange }) => {
  const handleFilterChange = (filterType, value) => {
    onFilterChange({
      ...filters,
      [filterType]: value
    });
  };

  const clearAllFilters = () => {
    onFilterChange({
      category: 'all',
      priority: 'all',
      impact: 'all',
      complexity: 'all'
    });
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value !== 'all');

  return (
    <div className="bg-white rounded-xl shadow-elevation-1 p-4 mb-6">
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={18} className="text-gray-500" />
          <span className="text-sm font-medium text-gray-700">Filters:</span>
        </div>

        {/* Category Filter */}
        <select
          value={filters?.category}
          onChange={(e) => handleFilterChange('category', e?.target?.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#1FB5A5]"
        >
          <option value="all">All Categories</option>
          <option value="Governance">Governance</option>
          <option value="Analytics">Analytics</option>
          <option value="Infrastructure">Infrastructure</option>
          <option value="Strategy">Strategy</option>
          <option value="Skills">Skills</option>
        </select>

        {/* Priority Filter */}
        <select
          value={filters?.priority}
          onChange={(e) => handleFilterChange('priority', e?.target?.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#1FB5A5]"
        >
          <option value="all">All Priorities</option>
          <option value="high">High Priority</option>
          <option value="medium">Medium Priority</option>
          <option value="low">Low Priority</option>
        </select>

        {/* Impact Filter */}
        <select
          value={filters?.impact}
          onChange={(e) => handleFilterChange('impact', e?.target?.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#1FB5A5]"
        >
          <option value="all">All Impact Levels</option>
          <option value="high">High Impact</option>
          <option value="medium">Medium Impact</option>
          <option value="low">Low Impact</option>
        </select>

        {/* Complexity Filter */}
        <select
          value={filters?.complexity}
          onChange={(e) => handleFilterChange('complexity', e?.target?.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#1FB5A5]"
        >
          <option value="all">All Complexity</option>
          <option value="low">Low Complexity</option>
          <option value="medium">Medium Complexity</option>
          <option value="high">High Complexity</option>
        </select>

        {/* Clear Filters Button */}
        {hasActiveFilters && (
          <button
            onClick={clearAllFilters}
            className="ml-auto px-4 py-2 text-sm font-medium text-gray-600 hover:text-[#1FB5A5] transition-colors flex items-center gap-2"
          >
            <Icon name="X" size={16} />
            Clear All
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterPanel;